<template>
  <div
    class="form-group"
    :class="[
      { 'input-group': hasIcon },
      { 'has-danger': error },
      { 'has-danger': isError },
      { 'input-group-focus': focused },
      { 'has-label': label || $slots.label },
      { 'has-success': !error && touched },
      { 'has-success': isValid },
      fgClasses
    ]"
  >
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{ label }}
        <span v-if="required">*</span>
      </label>
    </slot>

    <slot name="addonLeft">
      <div v-if="addonLeftIcon" class="input-group-addon input-group-prepend">
        <i :class="addonLeftIcon"></i>
      </div>
    </slot>
    <slot>
      <input
          :name="name"
        :value="value"
          v-on="listeners"
        v-bind="$attrs"
        class="form-control"
        :class="[{ valid: value && !error }, inputClasses]"
        aria-describedby="addon-right addon-left"
      />
    </slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon input-group-append" @click="addonRightIconClick">
          <font-awesome-icon v-if="addonRightIcon.indexOf('FA-')===0" :icon="addonRightIcon.replace('FA-', '')" />
        <i v-else :class="addonRightIcon"></i>
      </span>
    </slot>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div
        class="text-danger invalid-feedback"
        style="display: block"
        :class="{ 'mt-2': hasIcon }"
        v-if="error"
      >
        {{ error || errorMessage }}
      </div>
    </slot>
  </div>
</template>
<script>

export default {
  inheritAttrs: false,
  name: "fg-input",
  props: {
    name: String,
    isError: Boolean,
    isValid: Boolean,
    required: Boolean,
    label: String,
    error: String,
    fgClasses: String,
    labelClasses: String,
    inputClasses: String,
    value: [String, Number],
    addonRightIcon: String,
    addonRightIconClick: {
      type: Function,
      default: () => {}
    },
    addonLeftIcon: String,
  },
  data() {
    return {
      touched: false,
      focused: false,
      errorMessage: ''
    };
  },
  computed: {
    listeners() {
      return {
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur,
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    },
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      if (!this.touched && value) {
        this.touched = true;
      }
      this.$emit('update:value', value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    },
  },
};
</script>
<style lang="scss">
.input-group-addon {
    position: relative;
    z-index: 20000;

    .ClickOverlay { position: absolute; top: 0; right: 0; bottom: 0; left: 0; }
}
</style>
